module.exports = __webpack_public_path__ + "static/img/4992_phase_function_Paper_PointsHejduk_Prediction.87b454d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4992_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cKSV
// module chunks = 0